import fetch from "auth/FetchInterceptor";
import axios from "axios";
import {
  API_BASE_URL,
  API_BASE_URL_V2,
  EVENTS_API_BASE_URL,
} from "configs/AppConfig";
import { idea } from "react-syntax-highlighter/dist/cjs/styles/hljs";

const currentDomain = window.location.hostname;
const validDomains = ["localhost", "vudio"];
const isVudioDomain = validDomains.some((domain) =>
  currentDomain.includes(domain)
);
let customHeader = {
  "x-request-domain": isVudioDomain ? "VUDIO" : "LIVELY",
};

const ViewService = {};

ViewService.getPost = function (params) {
  return fetch({
    url: "/posts/1",
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getProductsList = function (params) {
  return fetch({
    url: `${API_BASE_URL}/products`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/videos/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.uploadUrlInVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/feeds/socialUrl/sync/s3`,
    method: "post",
    data: data,
  });
};

ViewService.addProduct = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/v2/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addProductMulti = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/v2/create/multi`,
    method: "post",
    data: data,
  });
};

ViewService.addPLPCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.EditPlpCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/plp-category-update`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addMultiplePLPCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/create/multi`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deletePlpCategory = function (data) {
  return fetch({
    url: `${API_BASE_URL}/plp-category/delete`,
    method: "delete",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPlpCategory = (params) => {
  return fetch({
    url: `${API_BASE_URL}/plp-category`,
    method: "get",
    params,
  });
};

ViewService.getVideos = function (params) {
  return fetch({
    url: `${API_BASE_URL}/videos`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteVideoFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/feeds/delete`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateRoom = function (data) {
  return fetch({
    url: `${API_BASE_URL}/call/video/generate/room`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateTokenForRoom = function (data) {
  return fetch({
    url: `${API_BASE_URL}/call/video/generate/call-token`,
    method: "post",
    data: data,
  });
};

ViewService.updateRoomStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/call/video/update/room`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.ongoingCall = function () {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/ongoing`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.isOngoingCall = function (params) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/is-ongoing`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.changeDevice = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/change/device`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.isDeviceChange = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/is/device-change`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getScheduleCallId = function (params) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/security-token/decrypt`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getProducts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/products`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteProduct = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/products/delete`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/videos/update`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getShoppableFeed = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getWidgetList = function (params) {
  return fetch({
    url: `${API_BASE_URL}/widget`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPLPWidgetList = function (id, params) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/collection/${id}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFeedList = function (id, params) {
  return fetch({
    url: `${API_BASE_URL}/widget/shoppable-feeds/${id}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getStoryList = function (id, params) {
  return fetch({
    url: `${API_BASE_URL}/widget/story/${id}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFeeds = function (params) {
  return fetch({
    url: `${API_BASE_URL}/feeds`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/feeds/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addFeedV1 = function (data) {
  return fetch({
    url: `${API_BASE_URL}/feeds/create/v1`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/v2/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/feeds/update`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/delete`,
    method: "delete",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.shoppableFeedUpdate = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/v2/update`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFormList = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/forms`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteForm = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/delete-form`,
    method: "delete",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createForm = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/create-form`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateForm = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/update-form`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.genrateCSVForm = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/generateforms`,
    method: "post",
    data,
  });
};

ViewService.editProduct = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/update`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getScheduleCall = function (params, status) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/status/${status}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInstantCall = function (params, status) {
  return fetch({
    url: `${API_BASE_URL}/instantcall/status/${status}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInstantCallUserInfo = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/get-customer-info`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postUpdateCallStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/instant-call/update`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.scheduleCallInvitation = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/call-invitation`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateScheduleCallStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/update`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.missedCalls = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/missed/calls`,
    method: "post",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateConferenceUser = function (data) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/update-conference-user`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addAgentDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/addUser`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAgentDetails = function () {
  return fetch({
    url: `${API_BASE_URL}/user/get-users`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLocations = function () {
  return fetch({
    url: `${API_BASE_URL}/company/warehouses`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//influencers api

ViewService.getAllOnboardedInfluencers = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/influencers`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.sentInvitationLink = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/influencer-invitation`,
    method: "get",
    params: params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.acceptInvitationLink = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/influencer-hiring`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAcceptedCompanies = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/get-company-list`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//influencers api

ViewService.getAllOnboardedInfluencers = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/influencers`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.sentInvitationLink = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/influencer-invitation`,
    method: "get",
    params: params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAcceptedCompanies = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/get-company-list`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInfluencerCompany = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/get-influencer-company`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.switchInfluencerCompany = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/influencers/switch-company`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addLocation = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/warehouse`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateLocation = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/warehouse`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateAgentDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/update-user`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteAgentDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/delete-user`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getRoleId = function () {
  return fetch({
    url: `${API_BASE_URL}/user/getRole`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCompanyInfo = function () {
  return fetch({
    url: `${API_BASE_URL}/company/info`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCurrencyCode = function () {
  return fetch({
    url: `${API_BASE_URL}/currency`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateCompany = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/update `,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.oneToOneCallHistory = function (params) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/call/history`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getConferenceUsersInfo = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/call/history`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getOneToOneAnalyticsInfo = function () {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/company/analytics`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postCSVFile = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/upload-file-to-s3`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
    },
  });
};

ViewService.postCSVFileShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/create-shoppable-feed-csv-upload`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
    },
  });
};

ViewService.getImportInfo = function (params) {
  return fetch({
    url: `${API_BASE_URL}/products/get-jobs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.markAsFinsihedCall = function (data) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/finish`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// ViewService.getShoppableFeedsAnalytics = function (path) {
//     return fetch({
//         url: `${API_BASE_URL}/sf/analytics/time/${path}`,
//         method: 'get',
//     })
// }

ViewService.postInstaAuthCode = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/auth`,
    method: "post",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postInstaFeeds = function () {
  return fetch({
    url: `${API_BASE_URL}/instagram/import-feeds`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postInstaOauthData = function (data) {
  return fetch({
    url: `${API_BASE_URL}/feeds/save-shopify-oauth`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postStoreInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shopify/marketplace-credentials`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getStoreConfiguration = function () {
  return fetch({
    url: `${API_BASE_URL}/shopify/get-shopify-credentials`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.registerWebhook = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shopify/register-webhook`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteWebhook = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shopify/delete-webhook`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.checkStatusWebhook = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shopify/check-webhook`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getShoppableWatchTime = function (params) {
  return fetch({
    url: `${API_BASE_URL}/feeds/calculate-feed-time`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getCustomerQuestions = function (params) {
  return fetch({
    url: `${API_BASE_URL}/qna/customer/questions`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.postFAQ = function (data) {
  return fetch({
    url: `${API_BASE_URL}/qna/faq`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getFAQ = function () {
  return fetch({
    url: `${API_BASE_URL}/qna/cms/faqs`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getSfAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAttachedShoppableFeed = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/cms/product/v2`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAttachedShoppableFeedPip = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/cms/v3`,
    method: "get",
    params,
  });
};

ViewService.updateAttachedShoppableFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/pdp/rank`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.productSync = function (data) {
  return fetch({
    url: `${API_BASE_URL}/products/sync/shopify`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTags = function () {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/tags`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postTags = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/tags`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postStoryInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/story/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getStories = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/story`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteStory = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/story/delete`,
    method: "delete",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.editStory = function (data, params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/story/update`,
    method: "post",
    data: data,
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCompanyOneToOnePlugin = function (params) {
  return fetch({
    url: `${API_BASE_URL}/conferenceUsers/getCompanyInfo`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getShoppableFeedConfiguration = function (params) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration/${params.company_id}`,
    method: "get",
    // params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateShoppableFeedConfigurationV2 = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration`,
    method: "put",
    data: data,
    // params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getShoppableFeedConfigurationV2 = function (
  company_id,
  layout_id,
  widget_id
) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration/${company_id}?layout_uuid=${layout_id}${
      widget_id != undefined ? `&widget_uuid=${widget_id}` : ""
    }`,
    method: "get",
    // params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLayoutsV1 = function () {
  return fetch({
    url: `${API_BASE_URL}/widget/global/configuration`,
    method: "get",
    // params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getProductWiseAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-performing-products-view-more`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getWidgetWiseAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-widgets-view-more`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFeedWiseAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-feeds-view_more`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFonts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/helper/get-font`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postOneToOneCustomizationInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/call-plugin-configuration`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postShoppableFeedsCustomizationInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/shoppable-feed-configuration`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateShoppableFeedsCustomizationInfo = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/configuration`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateStoryCustomization = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/story-configuration`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getBadge = function () {
  return fetch({
    url: `${API_BASE_URL}/badge`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getBadge = function () {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL}/widget/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInteractivePipId = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addQuestionInteractivePIP = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip/add-question`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateInteractivePIP = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip/update`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInteractivePipData = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/interactive-pip`,
    method: "get",
    params: params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//new Interactive PIP Api

ViewService.createInteractivePIPWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateInteractivePIPWidget = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/update/${widgetId}`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInteractivePipResponse = function (widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/fetch/${widgetId}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addInteractivePIPQuestion = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/add-questions/${widgetId}`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateInteractivePIPQuestion = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/update-question/${widgetId}`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteInteractivePIPQuestion = function (data, widgetId) {
  return fetch({
    url: `${API_BASE_URL_V2}/interactive-pip/delete-question/${widgetId}`,
    method: "delete",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//

ViewService.updateWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL}/widget/update`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteWidget = function (data) {
  return fetch({
    url: `${API_BASE_URL}/widget/delete`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateWidget = function (params) {
  return fetch({
    url: `${API_BASE_URL}/widget/generate-widget-code`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateScriptForWidget = function (params) {
  return fetch({
    url: `${API_BASE_URL}/scripts/generate-script`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getWidgets = function (params) {
  return fetch({
    url: `${API_BASE_URL}/widget/feeds`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getEngagementAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/engagement`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getEngagementAnalyticsSFWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/shoppable-feed-engagement`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getEngagementAnalyticsWidgetWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/widget-engagement?`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSalesAnalytics = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top_analytics`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSalesAnalyticsWidget = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/widget-details-analytics-page`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSalesAnalyticsSf = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/shoppable-feed-details-analytics-page`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTopProductSales = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-performing-products`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTopWidgetSales = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-widgets`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTopFeedsSales = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/top-feeds`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTopProductEngagement = function (params) {
  return fetch({
    url: `https://event.lively.li/api/streaming/top-products`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getFunnelData = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/funnel-api`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFunnelDataSFWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/shoppable-feed-funnel-api`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFunnelDataWidgetWise = function (params) {
  return fetch({
    url: `https://event.lively.li/api/sf/analytics/sales/widget-funnel-api`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getWidgetsAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/analytics`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getMetricAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/metric-analytics`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTopMetricAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/top-metrics`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.changeStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/change/status`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTopWidgets = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/top_widget_view_more`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTopFeeds = function (params) {
  return fetch({
    url: `${API_BASE_URL}/sf/analytics/top_feeds_view_more`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.sendCmsLogs = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/schedulecall/cms/logs`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Live Streaming Services

//Create Live Stream
ViewService.createLiveStream = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Get Live Stream Info
ViewService.getLiveStreamInfo = function (params, status) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/status/${status}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLiveStreamInfoByID = function (id) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLiveStreamConfiguration = function (id) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/cms/configuration`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateConfigurationLiveStream = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/configuration/update`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//mark as finished api for one 2 many  live-streaming/end
ViewService.updateStreamStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/end`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getThumbailUrl = function (params) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/upload/thumbnail`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Generate Zeego Token
ViewService.generateZeegoToken = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/token`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Set Streaming Status
ViewService.changeStreamingStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Set Streaming Status
ViewService.getHostPublisghingRights = function (id) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/verify-host/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Get Facebook auth status
ViewService.getFacebookAuthStatus = function (id) {
  return fetch({
    url: `${API_BASE_URL}/facebook/auth`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//update access token for facebook authentication
ViewService.updateAccessDetailsFacebook = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/facebook/auth`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getFacebookAccessTokenForLivestream = function (id) {
  return fetch({
    url: `${API_BASE_URL}/facebook/token/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getFacebookAccessTokenForLivestreamMulti = function (id, auth_id) {
  return fetch({
    url: `${API_BASE_URL}/facebook/v1/token/${id}/${auth_id}`,
    method: "get",
  });
};
ViewService.deleteUserFacebookAuth = function (data) {
  return fetch({
    url: `${API_BASE_URL}/facebook/user/auth`,
    method: "delete",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.checkFacebookPagesSession = function (data, platform) {
  return fetch({
    url: `${API_BASE_URL}/social-platform/check-session/${platform}`,
    method: "post",
    data: data,
  });
};

//instagram stream data check

ViewService.checkInstagramData = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/ingest/rtmp`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//youtube authentication

ViewService.getYouTubeAuthStatus = function () {
  return fetch({
    url: `${API_BASE_URL}/youtube/auth`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getYouTubeAuthUrl = function () {
  return fetch({
    url: `${API_BASE_URL}/youtube/auth-url`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateTokenYoutube = function (data) {
  return fetch({
    url: `${API_BASE_URL}/youtube/auth`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteYoutTubeAuth = function (data) {
  return fetch({
    url: `${API_BASE_URL}/youtube/user/auth`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getYoutubeAccessTokenForLivestream = function (id) {
  return fetch({
    url: `${API_BASE_URL}/youtube/token/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getYoutubeChatId = function (token, yt_video_id) {
  return axios.get("https://www.googleapis.com/youtube/v3/liveBroadcasts", {
    params: {
      part: "snippet",
      id: yt_video_id,
    },
    headers: {
      ...customHeader,
      Authorization: `Bearer ${token}`,
    },
  });
};

ViewService.getYoutubeChatResponse = function (params, accessToken) {
  return axios.get("https://www.googleapis.com/youtube/v3/liveChat/messages", {
    params: params,
    headers: {
      ...customHeader,
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

ViewService.postYoutubeComment = function (payload, youtubeToken) {
  return axios.post(
    "https://www.googleapis.com/youtube/v3/liveChat/messages?part=snippet",
    payload,
    {
      headers: {
        ...customHeader,
        Authorization: `Bearer ${youtubeToken}`,
      },
    }
  );
};

ViewService.brokerQueue = function (data) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/broker/queue`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postLivestreamComments = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/comments`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getLivestreamComments = function (params) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/comments`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postProductChangeTimestamp = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/insert-time-stamp`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCountryCode = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/country-code`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getPurpose = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/lively-products`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPlatforms = function () {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/platform`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTutorialInfo = function () {
  return fetch({
    url: `${API_BASE_URL}/cms/company/tutorial`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//shopify plans

ViewService.checkOnboardedOrNot = function (params) {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/onboarded`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getShopifyPlans = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/view/plans`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createSubscription = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.verifySubscriptionToken = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/verify`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.refreshToken = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/company/refresh/token`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//appsumo

ViewService.getCurrentPlanAppsumo = function () {
  return fetch({
    url: `${API_BASE_URL}/app-sumo/check-plan`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAttachedStory = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/story/pdp`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateAttachedStory = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/story/pdp/rank`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// raise a query

ViewService.raiseQuery = function (data) {
  return fetch({
    url: `${API_BASE_URL}/user/user-query`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//AGENCY LOGIN

ViewService.getAcceptedCompaniesAGGREGATOR = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/company/get-childs`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.switchChildCompany = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/company`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.sentAggregatorMail = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/invitation`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.acceptInvitationAggregator = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/integration`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//quizz

ViewService.getQuizes = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/quizs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createQuiz = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/create-quiz`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateQuiz = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/update-quiz`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteQuiz = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/delete-quiz`,
    method: "delete",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//polls

ViewService.getPolls = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/polls`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createPoll = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/create-poll`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updatePoll = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/update-poll`,
    method: "put",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deletePoll = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/delete-poll`,
    method: "delete",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getUsersStats = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/user/call/status`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//admin analytics

ViewService.getAdminAnalytics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/analytics`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Scaling Views
ViewService.updateScaling = function (data) {
  return fetch({
    url: `${API_BASE_URL}/company/shoppable-feed-configuration/scale`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//get promocode list company wise
ViewService.getPromocodeList = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/coupons`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//shopify import
ViewService.getAllProductsImport = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/products/shopify/import`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// coupon api

ViewService.getAllCoupons = function () {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/get-all-coupons`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCoupon = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/coupon/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateCoupon = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/coupon/update`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteCoupon = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/subscription/coupon/delete`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// AB Testing api

ViewService.updateTesting = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/ab-testing`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//accept migration
ViewService.acceptMigration = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/sync/shopify/app`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//social media post
ViewService.getSMPostList = function (params) {
  return fetch({
    url: `${API_BASE_URL}/social-media/post/queue`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createSMPost = function (data) {
  return fetch({
    url: `${API_BASE_URL}/social-media/post`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// instagram authentication apis

ViewService.checkInstagramSession = function (params) {
  return fetch({
    url: `${API_BASE_URL}/instagram/check-session`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createInstagramSession = function (data) {
  return fetch({
    url: `${API_BASE_URL}/instagram/session`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInstagramPages = function () {
  return fetch({
    url: `${API_BASE_URL}/instagram/auth`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getInstagramLiveStreamToken = function (streamId) {
  return fetch({
    url: `${API_BASE_URL}/instagram/token/${streamId}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postInstgramComment = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/instagram/comments`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateLivestream = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/meta`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteInstagramAuth = function (data) {
  return fetch({
    url: `${API_BASE_URL}/instagram/user/auth`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Vudio APIS
ViewService.generateVudioSignedUrl = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/generate-signed-url`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createPostTrigger = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/social-media/socialMediaPlatform/post`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVudioPosts = function (queryParams) {
  return fetch({
    url: `${API_BASE_URL}/cms/social-media/socialMediaPlatform/getPost${queryParams}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Automation Apis

ViewService.getAutomationVaribales = function (id) {
  return fetch({
    url: `${API_BASE_URL}/cms/social-media/get-variables/?id=${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAutomationTemplates = function (platform, type) {
  return fetch({
    url: `${API_BASE_URL}/cms/social-media/lively-default-template/?platform=${platform}&type=${type}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAutomation = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/social-media/company-templates`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAutomationsData = function (queryParams) {
  return fetch({
    url: `${API_BASE_URL}/cms/social-media/company-templates`,
    method: "get",
    params: queryParams,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// ai to avatar api

ViewService.createProductUrlLink = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/link`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateProductDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/link`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getScripts = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/scripts`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAvatarsList = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/avatars`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAvatarsVoices = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/voices`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.genratePreviewVideoUrl = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/feed/preview`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateVideoUrl = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/feed/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

export const getProductDataJS = async (url) => {
  url = url.split("?");

  const initial = url[0] + ".js";
  const latter = url[1];
  if (latter) {
    url = initial + "?" + latter;
  } else {
    url = initial;
  }
  const link = url;

  return await axios.get(`${link}`);
};

// url to video apis

ViewService.createJobId = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/video/create-ivc-job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchSongs = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/video/fetch-songs`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateJobId = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/video/update-ivc-job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVideoCreationStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/video/list-ivc-job`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAllVideos = function (data) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/videos`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAssociatedWidgets = function (id) {
  return fetch({
    url: `${API_BASE_URL}/widget/assoicated-widgets/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateVideoThumbnail = function (data) {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/shoppable-feeds/chunk-video/thumbnail `,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//aiVideoShoots api
ViewService.createAiVideoShootsVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/image-animate`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getStudioAICredits = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/credits`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIPrompts = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/images/prompt`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postFeedFeedback = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/feedback`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.postPreviewDetails = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/feed-meta`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Analytics Vudio

ViewService.getVudioAnalyticsData = function (type, params) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/v2/${type}?${queryString}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPDPProducts = function (params) {
  const queryString = new URLSearchParams(params).toString();
  return fetch({
    url: `${API_BASE_URL_V2}/v1/products?${queryString}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateProductPDPStatus = function (data, type) {
  return fetch({
    url: `${API_BASE_URL_V2}/v1/products/update/${type}`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVudioSocialMediaAnalyticsData = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/social-media/analytics`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//batch mode apis

ViewService.createAiBatchMode = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-studio/video/batch`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getBatchModeDataRangeWise = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-studio/video/batch`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.updateAiBatchModePost = function (data, configurationId) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-studio/video/batch/${configurationId}`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteBatchModePost = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-studio/video/post`,
    method: "delete",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
//update sf products ranking api
ViewService.updateProductsRanking = function (data, sfId) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/v2/product/rank/${sfId}`,
    method: "post",
    data,
  });
};

//hover media product apis
ViewService.getAttachedHoverReel = function (product_id) {
  return fetch({
    url: `${API_BASE_URL_V2}/products/map/video/${product_id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateAttacherdHoverReel = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/products/map/video`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//facebook group api live stream
ViewService.getFacebookGroups = function () {
  return fetch({
    url: `${API_BASE_URL}/facebook/persistent-key`,
    method: "get",
  });
};

ViewService.deleteFacebookGroup = function (data) {
  return fetch({
    url: `${API_BASE_URL}/facebook/persistent-key`,
    method: "delete",
    data,
  });
};

ViewService.createFacebookGroup = function (data) {
  return fetch({
    url: `${API_BASE_URL}/facebook/persistent-key`,
    method: "post",
    data,
  });
};

//marketPlace apis(amazon)

ViewService.getAmazonRedirectUrl = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/amazon/authorize`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAmazonConnectedAccountStatus = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/amazon/check-registration`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.connectAmazonAccount = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/amazon/auth`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getProductDetailsFromAIFeed = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/feed-product`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Jog ai intgeration

ViewService.getCurrentAIMode = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/company/switch-ai-feed-mode`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createProductUrlLinkJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/project`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateProductDetailsJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/project`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getScriptsJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/scripts`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAvatarsListJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/avatars`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAvatarsVoicesJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/voices`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generatePreviewVideoUrlJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/feed/preview`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPreviewStatusPreviewVideoUrlJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/feed/preview`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateVideoUrlJogAI = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/jog-ai/feed/create`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getStoryAttachedWidgets = function (id, params) {
  return fetch({
    url: `${API_BASE_URL_V2}/widget/story/${id}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getStoryAttachedProducts = function (id, params) {
  return fetch({
    url: `${API_BASE_URL_V2}/products/story/${id}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getQueueStatusAIFeed = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/queue-status`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSubscriptionPlans = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/view/plans`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// Live Stream Poll Apis

ViewService.createLiveStreamPoll = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/live-streaming/poll`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.startLiveStreamPoll = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/live-streaming/poll/${id}/start`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.endLiveStreamPoll = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/live-streaming/poll/${id}/end`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPollResults = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/live-streaming/poll/${id}/result`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPollInfo = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/live-streaming/poll`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCurrentSubscriptionPlan = function () {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/current/plan`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//cinematic video shoots apis
ViewService.generateAiPrompt = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/images/prompt`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchSongsCinematic = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/video/fetch-songs/v2`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateCinematicVideo = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateCinematicVideoV2 = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/v3/auto`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//collection ranking apis
ViewService.getAttachedReelsCollection = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/v3/collection/pdp`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.updateAttachedCollectionReelRanking = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/plp/rank`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAttachedStoryCollection = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/story/v3/collection/pdp`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.updateAttachedCollectionStoryRanking = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/story/plp/rank`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//credits History
ViewService.getCreditsHistory = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/credits-history`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//RefreshAnalytics
ViewService.getAnalyticsRefreshTime = function (params) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/v2/overview/last_refresh`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Admin Custom Plan Apis
ViewService.getCustomPlansAdmin = function (params) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/custom`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Onboarding APis
ViewService.getTutorialDetails = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/fetch-tutorial`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateCustomPlansAdmin = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/custom`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCustomPlansAdmin = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/custom`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateTutorialProgress = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/update-progress`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAnalyticsJobs = function (params) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/v2/jobs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAnalyticsJob = function (data) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/v2/jobs`,
    method: "post",
    data: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getPresignedUrlAnalyticsCSV = function (params) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/v2/generate_signed_url`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Admin Custom Plan Apis
ViewService.getCustomPlansAdmin = function (params) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/custom`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateCustomPlansAdmin = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/custom`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCustomPlansAdmin = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/custom`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.encryptEditorToken = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/company/video-editor/encrypt`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//livestream analytics
ViewService.getLivestreamAnalyticsData = function (params) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/live-stream/summary`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLivestreamAnalyticsDataTopPerformingLiveStream = function (
  params
) {
  return fetch({
    url: `${EVENTS_API_BASE_URL}/analytics/live-stream/top_performing`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Admin API Switch Apis
ViewService.getAPISwitchData = function (params) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/switch-ai-feed-mode`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateAPISwitchData = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/switch-ai-feed-mode`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//cinematic v3.1
ViewService.getDefaultPromptsCinematicV3 = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/images/prompt`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTemplatesDataCinematicV3 = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/template`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLogoWatermarkCinematicV3 = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/branding`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateVideoCinematicV3 = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/v3/diy`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateVideoCinematicV3Edit = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/edit`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateLogoWaterMark = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/branding`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.checkValidImageUrlCinematic = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/image/validate`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
//Admin Brand Listing Apis

ViewService.getAllOnboardedBrands = function (params) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/company-list`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLivelyProducts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/lively-products`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.blockBrandPlugin = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/block/plugin`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.unblockBrandPlugin = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/unblock/plugin`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.blockBrandCMS = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/block/cms`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.unblockBrandCMS = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/unblock/cms`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//vton apis
ViewService.generateVtonImages = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/create/vton/job`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//magento apis
ViewService.checkMagentoConnected = function (params) {
  return fetch({
    url: `${API_BASE_URL}/magento/validate/token`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getMagentoIntgerationDetails = function (params) {
  return fetch({
    url: `${API_BASE_URL}/magento/integration/details`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getClothTypes = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/category`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVudioAIModels = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,

    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchDecryptToken = async (params) => {
  return fetch({
    url: `${API_BASE_URL}/plugin/company/video-editor/decrypt`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchUserInfo = async () => {
  return fetch({
    url: `${API_BASE_URL_V2}/user/user-info`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

//region mapping

ViewService.fetchAvailableMarkets = async () => {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/shopify-markets`,
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

ViewService.syncAvailableMarkets = async () => {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/shopify-markets`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

ViewService.saveMarkets = async (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/shopify-markets/group-sf`,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  });
};

//Aggregator Company Create

ViewService.createChildCompanyAggregator = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/create/child`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//vton apis

ViewService.getModelPoses = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model/poses`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVudioAIModels = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCustomVudioAIModels = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateVudioAIModels = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createModelFromPrompt = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model/job`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchQueueStatusPromptModel = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model/job-queue`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.saveGPUCreds = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/save/gpu_creds`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchBackgrounds = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAIBackground = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchAiBackgroundPreviewStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview/status`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.saveAiBackgroundPreview = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background-preview/save`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// Vudio Tutorial API's

ViewService.getVudioTutorialTopics = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/doc`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getVudioTutorialContent = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/doc`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

//syncing feed status
ViewService.getSyncingStatus = function (params) {
  return fetch({
    url: `${API_BASE_URL}/products/get-jobs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAgentExecutions = function () {
  return fetch({
    url: `${API_BASE_URL}/cms/ai-agents/executions`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAgentExecutionByID = function (id) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai-agents/executions/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAiAgentConfig = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai-agents/workflow-configs`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAiAgentExecution = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai-agents/workflow-configs/execution`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// custom link

ViewService.getCustomLinks = (params) => {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/custom-link`,
    method: "get",
    params,
  });
};

ViewService.addCustomLinks = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/custom-link/create`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateCustomLink = function (payload, id) {
  return fetch({
    url: `${API_BASE_URL}/shoppable-feeds/custom-link/${id}`,
    method: "put",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

// custom plan apis

ViewService.fetchSubPlansAdmin = function (params) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/sub-plans`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateSubPlansAdmin = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/plans/metrics`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchSubPlans = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/sub-plans`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCustomPlan = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/custom-plan`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchCurrentCustomPlanProducts = function (planId, params) {
  return fetch({
    url: planId
      ? `${API_BASE_URL_V2}/company/custom-plan/${planId}`
      : `${API_BASE_URL_V2}/company/custom-plan`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateCurrentCustomPlanProducts = function (planId, data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/custom-plan/${planId}`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAllTags = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTagFeeds = function (params) {
  return fetch({
    url: `${API_BASE_URL}/feeds`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.assignTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/add/tag`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createFolder = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage/create/folder`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFolders = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteFolder = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage/delete`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateFolder = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage/update/folder`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Face Swap apis
ViewService.createFaceSwapJob = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/create/face_swap/job`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFaceSwapJobById = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/face_swap/jobs/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateImagesObjectReplacer = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/object-replacer`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getOrderStatusObjectReplacer = (params, orderId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/get-output/${orderId}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchBackgrounds = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateBackgroundRemoverImage = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-remover`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateBackgroundReplacerImage = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-replacer`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getJobStatusBackgroundReplacer = (params, orderId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/get-background-replacer/${orderId}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAIBackground = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchAiBackgroundPreviewStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview/status`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createTextToImageJob = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/create/text-to-image/job`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTextToImageJobById = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/text-to-image/jobs/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAiTextGeneratedImages = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/text-to-image-list`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.aiAdsCreateJob = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/video-ads`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.aiAdsJobStatus = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/video-ads/status`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateAiAdsJob = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/video-ads`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.aiAdsFonts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/open/fonts`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIVideoShootQueueData = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/open/video-shoot/jobs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchBackgrounds = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAIBackground = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchAiBackgroundPreviewStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview/status`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.saveAiBackgroundPreview = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background-preview/save`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCustomVudioAIModels = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateVudioAIModels = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchAiBackgroundPreviewStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview/status`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createTextToImageJob = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/create/text-to-image/job`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTextToImageJobById = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/text-to-image/jobs/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAiTextGeneratedImages = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/text-to-image-list`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.aiAdsCreateJob = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/video-ads`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.aiAdsJobStatus = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/video-ads/status`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateAiAdsJob = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/video-ads`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.aiAdsFonts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/open/fonts`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchBackgrounds = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAIBackground = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchAiBackgroundPreviewStatus = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-preview/status`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.saveAiBackgroundPreview = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background-preview/save`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCustomVudioAIModels = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateVudioAIModels = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.SFMappingWithCollection = (data, widgetId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/tag/mapping/${widgetId}`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getWidgetCollections = (params, widgetId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/shoppable-feeds/tag/mapping/${widgetId}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchEditorImageAssets = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/fetch-image-assets`,
    method: "get",
    params: data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getImagesFrameTypes = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/images/frame/classify`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.vudioFonts = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/ai/open/fonts`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchBackgrounds = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createBackgroundPreviewJob = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-replacer`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getBackgroundPreviewJobStatus = function (id, params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/get-background-replacer/${id}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAvatarLayouts = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/avatar-layout`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVideoFrames = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/prompt`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createCustomFrameJob = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/prompt`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCustomFrameJobStatus = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/prompt-status`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteCustomFrame = (params, frame_id) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/prompt/${frame_id}`,
    method: "delete",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Media Upload Using Job Id
ViewService.createNewJobId = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/add/jobId`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createUpscaleJob = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/create/image-upscale/job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getUpscaleJobById = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/image-upscale/jobs/${id}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAllTags = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getTagFeeds = function (params) {
  return fetch({
    url: `${API_BASE_URL}/feeds`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/tag`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.assignTag = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/feeds/add/tag`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createFolder = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage/create/folder`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getFolders = function (params) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteFolder = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage/delete`,
    method: "delete",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateFolder = function (data) {
  return fetch({
    url: `${API_BASE_URL}/cms/content-manage/update/folder`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateBackgroundReplacerImage = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/background-replacer`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getJobStatusBackgroundReplacer = (params, orderId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/get-background-replacer/${orderId}`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIGraphicsTemplate = () => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-graphic/templates`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.aiGraphicsTemplateIngridents = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-graphic/generate`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createAIGraphics = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-graphic/create`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateAIGraphics = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-graphic/update`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIGraphicsData = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-graphic`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getModelFaceSwapJobs = (modelId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/models/${modelId}/status`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createModelPoses = function (data) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton/model/poses`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSubscriptionHistory = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/histories`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCreditHistory = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/company/credits-history`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getBillingDetails = () => {
  return fetch({
    url: `${API_BASE_URL_V2}/company/billing_details`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateBillingDetails = (data) => {
  return fetch({
    url: `${API_BASE_URL}/company/update`,
    method: "put",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCreditsPackages = () => {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/plans/one-time`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getCountryState = (params) => {
  return fetch({
    url: `${API_BASE_URL}/helper/country/state`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVtonJobs = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton-jobs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};
ViewService.getVtonJobById = (jobId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/vton-jobs/${jobId}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.addCustomMusic = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/company/add-music`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSubscriptionStatus = (subscriptionId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/status/${subscriptionId}?source=razorpay`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.cancelSubscription = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/subscription/cancel`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVtonModelData = (modelId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/models/${modelId}/poses`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateModelWithPoses = function (model_id, payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/models/${model_id}`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteVtonModel = function (model_id) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/models/${model_id}`,
    method: "delete",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSmileysDataAll = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/emoji`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getVtonModelData = (modelId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/models/${modelId}/poses`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.updateModelWithPoses = function (model_id, payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/models/${model_id}`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteVtonModel = function (model_id) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/models/${model_id}`,
    method: "delete",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getSmileysDataTrending = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/emoji/trending`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getSmileysDataRecentlyUsed = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/emoji/recent`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.regenerateVton = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-regenerate`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getBrollPhotosTrending = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/pexels/curated`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getBrollVideosTrending = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/pexels/popular`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getBrollVideosCurated = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/pexels/search-videos`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getBrollPhotosCurated = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/pexels/search-photos`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.geminiTestGeneration = function (payload) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/gemini-image-generation`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.sendOTP = (data) => {
  return fetch({
    url: `${API_BASE_URL}/user/send-otp`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data: data,
  });
};

ViewService.verifyOTP = (data) => {
  return fetch({
    url: `${API_BASE_URL}/user/verify-otp`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data: data,
  });
};

ViewService.getPromptByDuration = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/prompt-by-duration`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getMurfAIVoices = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/get-murfai-voices`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getScriptDurationJobId = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/generate-script-audio`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.fetchScriptDurationFromJobId = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/fetch-script-audio`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.createPoseFaceCombination = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/pose_combinations`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.createVtonPosesV2 = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-poses`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchVtonPosesV2 = function (params) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-poses`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.createAdminPoses = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/admin/vton-poses`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteVtonPoseV2 = function (poseId) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-poses/${poseId}`,
    method: "delete",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.editVtonPosesV2 = function (payload, poseId) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-poses/${poseId}/edit`,
    method: "post",
    data: payload,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.covertImage = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/scale/image`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.getJobIdData = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/video-shoot/jobs`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.postPreviewDetailsAIVideoShoot = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session`,
    method: "put",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.getPreviewDetailsAIVideoShoot = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.updateCompanyVtonSwitch = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/company/switch-ai-feed-mode`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.getAIAdsCategoryData = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/category`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsProductShoots = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/product-template`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsModelStyles = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/model-template`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsModels = () => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/models`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsProductMets = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/product-meta`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsProductMeta = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/product-meta`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.AIAdsBackendJob = () => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/create-backend-job`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.AIAdsJob = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/create-job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.AIAdsFetchJob = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/jobs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getLivestreamGlobalAnalytcis = (params) => {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/global/analytics`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getLivestreamChunks = (params) => {
  return fetch({
    url: `${API_BASE_URL}/live-streaming/global/analytics/chunks`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getVtonOverallAnalytics = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/analytics/vton/overall`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getAvatarVideosAnalytics = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/analytics/avatar-videos/overall`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.getImageToVideoAnalytics = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/analytics/image-to-video/overall`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.setPassword = (data) => {
  return fetch({
    url: `${API_BASE_URL}/user/update-user`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsCategoryData = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/category`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsProductShoots = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/product-template`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsModelStyles = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/model-template`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsModels = () => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/models`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsProductMets = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/product-meta`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getAIAdsProductMeta = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/product-meta`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.AIAdsBackendJob = () => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/create-backend-job`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.AIAdsJob = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/create-job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.AIAdsFetchJob = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/jobs`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getImageToVideoAnalytics = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/analytics/image-to-video/overall`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

//Speaking image

ViewService.generatePromptImage = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/generate-prompt-image`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateMaskUrls = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/generate-mask-urls`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateScriptAudio = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/generate-script-audio`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateSpeakingVideo = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/create-job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchSpeakingImageJob = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/fetch-job`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//Speaking image

ViewService.generatePromptImage = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/generate-prompt-image`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateMaskUrls = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/generate-mask-urls`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateScriptAudio = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/generate-script-audio`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateSpeakingVideo = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/create-job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchSpeakingImageJob = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/fetch-job`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.fetchShopifyStoreProducts = (params) => {
  return fetch({
    url: `${API_BASE_URL}/products/graphql/fetch`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateAIBackgrondPreview = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/open/background/generate-preview`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.generateSpaekingImgCustomPrompts = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/segment-script`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

//VTON BULK Upload Methods

ViewService.uploadVTONBulkCSV = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton/bulk/upload`,
    method: "post",
    data,
    headers: {
        ...customHeader,
      "Content-Type": "multipart/form-data",
    },
  });
};

ViewService.getVTONBulkUploadStatus = (uploadId) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton/bulk/status/${uploadId}`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.getVTONBulkUploads = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton/bulk/uploads`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.downloadVTONErrorReport = async (uploadId) => {
  console.log("Fetching error report for uploadId:", uploadId);

  try {
    const response = await fetch(
      `${API_BASE_URL_V2}/ai/vton/bulk/error-report/${uploadId}`,
      {
        method: "GET",
        headers: {
          ...customHeader,
        },
      }
    );

    let csvText;

    if (typeof response === "function") {
      csvText = await response.text();
    } else if (typeof response === "string") {
      csvText = response;
    } else {
      csvText = await response.blob().then((blob) => blob.text());
    }

    const blob = new Blob([csvText], { type: "text/csv;charset=utf-8;" });

    return blob;
  } catch (error) {
    console.error("Service error:", error);
    throw error;
  }
};

ViewService.updateVTONJob = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-update`,
    method: "post",
    data: payload,
     headers: {
        ...customHeader,
   "Content-Type": "application/json",
    },
  });
};


ViewService.fetchVtonCategories = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-categories`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};


ViewService.addVtonCategories = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-categories`,
    method: "post",
    data: payload,
     headers: {
        ...customHeader,
   "Content-Type": "application/json",
    },
  });
};


ViewService.deleteVtonCategory = function (id) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-categories/${id}`,
    method: "delete",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.reGenerateSpeakingImage = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/regenerate-job`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};



ViewService.getVtonModelAPlusBasicAnalytics = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/analytics/vton/model-a-plus-basic`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};


ViewService.getVtonModelAPlusProAnalytics = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/analytics/vton/model-a-plus-pro`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.veoCharacterMapping = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/character-mapping`,
    method: "get",
    params,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.veoGenerateScript = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-speaking-image/generate-script`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};


ViewService.getGeminiTestAnalytics = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/analytics/test-dashboard`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};


ViewService.updateVTONNames = function (payload) {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/vton-name/edit`,
    method: "post",
    data: payload,
     headers: {
        ...customHeader,
   "Content-Type": "application/json",
    },
  });
};
// drafts apis

ViewService.getActiveSessionAIVideoShoot = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.createSessionAIVideoShoot = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session`,
    method: "post",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.updateSessionAIVideoShoot = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session`,
    method: "put",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.deleteSessionAIVideoShoot = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session`,
    method: "delete",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.getDraftAIVideoShoot = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session/draft`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.updateDraftAIVideoShoot = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session`,
    method: "put",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    data,
  });
};

ViewService.getAllDraftsAIVideoShoot = (params) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai/video/shoot/session/draft`,
    method: "get",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
    params,
  });
};

ViewService.addAdminBackground = function (data) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/backgrounds/add`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.deleteBackground = function (id) {
  return fetch({
    url: `${API_BASE_URL}/admin/company/backgrounds/${id}`,
    method: "delete",
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};


ViewService.AIAdsUploadProductTemplates = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/product-template`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};

ViewService.AIAdsUploadModelTemplates = (data) => {
  return fetch({
    url: `${API_BASE_URL_V2}/ai-ads/model-template`,
    method: "post",
    data,
    headers: {
      ...customHeader,
      "Content-Type": "application/json",
    },
  });
};




export default ViewService;
